import { render, staticRenderFns } from "./Classificators.vue?vue&type=template&id=0c3de0a0"
import script from "./Classificators.vue?vue&type=script&lang=js"
export * from "./Classificators.vue?vue&type=script&lang=js"
import style0 from "./Classificators.vue?vue&type=style&index=0&id=0c3de0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports